import React, { useEffect, useState } from "react";
import api from "../../api/api";
import "../../css/Employee.css";
import "../../css/Addemployee.css";
import { Link } from "react-router-dom";

const AddEmployee = () => {
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [officeShifts, setOfficeShifts] = useState([]);
  const [states, setStates] = useState([]);

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    gender: "",
    birth_date: "",
    email: "",
    country: "",
    city: "",
    district: "",
    state: "",
    village: "", // Adding village to formData
    joining_date: "",
    company_id: "",
    department_id: "",
    designation_id: "",
    office_shift_id: "",
    basic_salary: "",
  });

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await api.get("/get/company");
        if (res.data.success) {
          setCompanies(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    const fetchStates = async () => {
      try {
        const res = await api.get("/get/state");
        if (res.data.success) {
          setStates(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchCompanies();
    fetchStates(); // 👈 Add this
  }, []);

  const fetchDepartments = async (company_id) => {
    try {
      const res = await api.post("/get/department", { company_id });
      if (res.data.success) {
        setDepartments(res.data.data);
      } else {
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      setDepartments([]);
    }
  };

  const fetchDesignations = async (company_id, department_id) => {
    try {
      const res = await api.post("/get/designation", {
        company_id,
        department_id,
      });
      if (res.data.success) {
        setDesignations(res.data.data);
      } else {
        setDesignations([]);
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
      setDesignations([]);
    }
  };

  const fetchOfficeShifts = async (company_id) => {
    try {
      const res = await api.post("/get/officeShift", { company_id });
      if (res.data.success) {
        setOfficeShifts(res.data.data);
      } else {
        setOfficeShifts([]);
      }
    } catch (error) {
      console.error("Error fetching office shifts:", error);
      setOfficeShifts([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "company_id") {
      setFormData((prev) => ({
        ...prev,
        department_id: "",
        designation_id: "",
        office_shift_id: "",
      }));
      setDepartments([]);
      setDesignations([]);
      setOfficeShifts([]);
      fetchDepartments(value);
      fetchOfficeShifts(value);
    }

    if (name === "department_id") {
      const company_id = formData.company_id;
      setFormData((prev) => ({
        ...prev,
        designation_id: "",
      }));
      if (company_id && value) {
        fetchDesignations(company_id, value);
      } else {
        setDesignations([]);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      firstname: "",
      lastname: "",
      phone: "",
      gender: "",
      birth_date: "",
      email: "",
      country: "",
      city: "",
      district: "",
      state: "",
      village: "",
      joining_date: "",
      company_id: "",
      department_id: "",
      designation_id: "",
      office_shift_id: "",
      basic_salary: "",
    });

    setDepartments([]);
    setDesignations([]);
    setOfficeShifts([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Required fields list
    const requiredFields = [
      { name: "firstname", label: "First Name" },
      { name: "lastname", label: "Last Name" },
      { name: "email", label: "Email Address" },
      { name: "phone", label: "Phone Number" },
      { name: "gender", label: "Gender" },
      { name: "company_id", label: "Company" },
      { name: "department_id", label: "Department" },
      { name: "designation_id", label: "Designation" },
      { name: "office_shift_id", label: "Office Shift" },
      { name: "state", label: "State" },
      { name: "country", label: "Country" },
    ];

    // Step-by-step validation alerts for empty required fields
    for (let field of requiredFields) {
      if (
        !formData[field.name] ||
        formData[field.name].toString().trim() === ""
      ) {
        alert(`${field.label} is required.`);
        return; // stop submission on first empty required field
      }
    }

    // If all required fields are filled, submit the form
    try {
      const res = await api.post("/add/employee", formData);
      console.log("Employee added:", res.data);

      if (res.data.success) {
        alert("Employee added successfully!");
        resetForm(); // 🔁 Reset the form after successful submission
      } else {
        alert(res.data.message || "Failed to add employee.");
      }
    } catch (err) {
      console.error("Error:", err);
      if (err.response && err.response.data && err.response.data.message) {
        alert(err.response.data.message);
      } else {
        alert("Failed to add employee.");
      }
    }
  };

  return (
    <section className="employee-section add-employee-001">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Add Employee</h2>
          <div className="btn-csv-001">
            <Link to="/admin-dashboard/csv">Upload Employee</Link>
          </div>
        </div>
        <div className="add-wrapper">
          <div className="content-wrapper">
            <h2>Add Employee Details</h2>
            <form onSubmit={handleSubmit}>
              <div className="row-wrapper">
                <div className="main-wrapper">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstname"
                    placeholder="First Name"
                    value={formData.firstname}
                    onChange={handleChange}
                  />
                </div>
                <div className="main-wrapper">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastname"
                    placeholder="Last Name"
                    value={formData.lastname}
                    onChange={handleChange}
                  />
                </div>
                <div className="main-wrapper custom-select">
                  <label>Gender</label>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="">Choose Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>

                <div className="main-wrapper">
                  <label>Birth Date</label>
                  <input
                    type="date"
                    name="birth_date"
                    value={formData.birth_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="main-wrapper">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="main-wrapper">
                  <label>Country</label>
                  <input
                    type="text"
                    name="country"
                    placeholder="Country"
                    value={formData.country}
                    onChange={handleChange}
                  />
                </div>

                <div className="main-wrapper">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="main-wrapper">
                  <label>Joining Date</label>
                  <input
                    type="date"
                    name="joining_date"
                    value={formData.joining_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="main-wrapper custom-select">
                  <label>Company</label>
                  <select
                    name="company_id"
                    value={formData.company_id}
                    onChange={handleChange}
                  >
                    <option value="">Choose Company</option>
                    {companies.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>
                <div className="main-wrapper custom-select">
                  <label>Department</label>
                  <select
                    name="department_id"
                    value={formData.department_id}
                    onChange={handleChange}
                  >
                    <option value="">Choose Department</option>
                    {departments.map((dept) => (
                      <option key={dept.id} value={dept.id}>
                        {dept.department}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>

                <div className="main-wrapper custom-select">
                  <label>Designation</label>
                  <select
                    name="designation_id"
                    value={formData.designation_id}
                    onChange={handleChange}
                  >
                    <option value="">Choose Designation</option>
                    {designations.map((desig) => (
                      <option key={desig.id} value={desig.id}>
                        {desig.designation}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>
                <div className="main-wrapper custom-select">
                  <label>Office Shift</label>
                  <select
                    name="office_shift_id"
                    value={formData.office_shift_id}
                    onChange={handleChange}
                  >
                    <option value="">Choose Office Shift</option>
                    {officeShifts.map((shift) => (
                      <option key={shift.id} value={shift.id}>
                        {shift.name}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>

                <div className="main-wrapper">
                  <label>Basic Salary</label>
                  <input
                    type="number"
                    name="basic_salary"
                    placeholder="Basic Salary"
                    value={formData.basic_salary}
                    onChange={handleChange}
                  />
                </div>

                <div className="main-wrapper custom-select">
                  <label>State</label>
                  <select
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                  >
                    <option value="">Choose State</option>
                    {states.map((state) => (
                      <option key={state.state_id} value={state.state_title}>
                        {state.state_title}
                      </option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down select-icon"></i>
                </div>

                <div className="main-wrapper">
                  <label>District</label>
                  <input
                    type="text"
                    name="district"
                    placeholder="District"
                    value={formData.district}
                    onChange={handleChange}
                  />
                </div>

                <div className="main-wrapper">
                  <label>City</label>
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className="main-wrapper">
                  <label>Village</label>
                  <input
                    type="text"
                    name="village"
                    placeholder="Village"
                    value={formData.village}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="btn-sub">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddEmployee;
